import { useEffect } from 'react';
import { Popup } from './styles';

import exitIntent from 'exit-intent';

export const ExitIntentPopup = ({ show, goTo, setShow }) => {
  useEffect(() => {
    exitIntent({
      threshold: 20,
      maxDisplays: 1,
      eventThrottle: 200,
      onExitIntent: () => {
        setShow(true);
      }
    });
  }, []);

  return show ? (
    <Popup
      id="popup"
      onClick={() => {
        setShow(false);
      }}
    >
      <div className="modal-content">
        <div className="webinar">Webinar gratuito</div>
        <h2 style={{ textAlign: 'center' }}>Tech SEO para agências digitais</h2>
        <div className="subtitle">
          A importância da alta performance para
          <br /> sites que geram resultados
        </div>

        <div className="date">Dia 07 de Junho de 2022, às 19h, ao vivo</div>
        <button className="subscribe" onClick={() => window.open(goTo)}>
          Inscreva-se gratuitamente
        </button>
        <img src="/webinar.png" />
      </div>
    </Popup>
  ) : null;
};
